import {
  severityRatingOptions,
  getEventCategoryByServices,
} from 'containers/Pages/Events/Layouts';
import {
  eventStatusFilterOption as eventStatus,
  eventDistributionOptionsForFilter,
} from 'utils/constants/eventStatus';
import { PAGE_NAME } from 'utils/constants';
import API from 'services/api';
import { v4 } from 'uuid';

const baseEventFilter = ({
  bizClients,
  category,
  minDate,
  currentPage,
  incidentStatus,
  services,
}) => {
  const filters = {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'category',
        field: 'category',
        type: 'select',
        options: getEventCategoryByServices(services),
      },
      {
        label: 'Type',
        field: 'type',
        type: 'async-select',
        disabled: !category,
        useAsyncInFilters: true,
        fetchOptions: API.fetchEventTypes,
        optionLabelKey: 'typeName',
        dataTransform: ({ data }) => {
          if (!category) return [{ typeName: 'Select category to view types' }];
          return data.map(et => ({
            ...et,
            id: et.id !== '' ? et.id : v4(), // assign the id as the static categories does not have id
          }));
        },
        resetWhen: [
          {
            value: category,
            condition: val => {
              return val;
            },
          },
        ],
        fetchFilters: {
          category: category,
          archived: false,
        },
        multiple: false,
      },

      {
        label: 'incidentStatus',
        field: 'incidentStatus',
        type: 'select',
        multiple: true,
        options: incidentStatus,
        placeholder: '',
      },
    ],
    AdvancedFilters: [
      {
        label: 'distribution',
        field: 'distribution',
        type: 'select',
        options: eventDistributionOptionsForFilter,
      },
      currentPage !== PAGE_NAME.REGION && {
        label: 'involvedCompany',
        field: 'businessClient',
        type: 'select',
        options: bizClients.map(item => ({
          id: item.name,
          name: item.name,
        })),
        size: 'large',
      },
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'publishedStatus',
        field: 'status',
        type: 'select',
        options: eventStatus,
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
      {
        label: 'severityRating',
        field: 'severityRating',
        type: 'select',
        multiple: true,
        options: severityRatingOptions,
      },
    ],
  };
  return filters;
};

export const filters = ({
  bizClients,
  category,
  minDate,
  currentPage,
  incidentStatus,
  services,
}) => {
  return baseEventFilter({
    bizClients,
    category,
    minDate,
    currentPage,
    incidentStatus,
    services,
  });
};
